enum Routes {
  Landing = "/landing.html",
  FormBuilder = "/form_builder.html",
  Form = "/form.html",
}

export { Routes };
